<template>
    <div class="audit-equipment-summary">

            <div class="table-responsive">
                <table class="mb-3">
                    <tr>
                        <th>Vehicle ID</th>
                        <td v-if="auditEquipment">
                            {{ auditEquipment.equipment.vehicle_id }}
                        </td>
                        <th>Status</th>
                        <td>
                            <audit-equipment-status-badge
                                :audit-equipment="auditEquipment"/>
                        </td>
                        <th>Issue Type</th>
                        <td>
                            {{ categoryLabel(auditEquipment.category) }}
                        </td>
                    </tr>
                    <tr>
                        <th>Follow Up Due</th>
                        <td>
                            <timestamp :date="auditEquipment.follow_up"/>
                        </td>
                        <th>Response Status</th>
                        <td>
                            <audit-equipment-response-badge
                                :audit-equipment="auditEquipment"/>
                        </td>
                    </tr>
                    <tr>
                        <th>Auditor Notes</th>
                        <td>{{ auditEquipment.comment }}</td>
                    </tr>
                </table>
            </div>

    </div>
</template>

<script>
import AuditEquipment from '@/models/AuditEquipment'

export default {
    name: 'auditEquipmentSummary',
    props: {
        auditEquipment: Object,
    },
    methods: {
        categoryLabel (category) {
            return AuditEquipment.categoryOptions[category]
        }
    }
}
</script>

<style scoped>

</style>